"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequirementsStatus = exports.Requirements = void 0;
/**
 * @exmaple ``{
  KYC_1 = 'KYC_1',
  KYC_2 = 'KYC_2',
  KYB_1 = 'KYB_1'
}``

 */
var Requirements;
(function (Requirements) {
    Requirements["KYC"] = "KYC";
})(Requirements = exports.Requirements || (exports.Requirements = {}));
var RequirementsStatus;
(function (RequirementsStatus) {
    RequirementsStatus["PENDING"] = "PENDING";
    RequirementsStatus["COMPLETED"] = "COMPLETED";
    RequirementsStatus["FAILED"] = "FAILED";
})(RequirementsStatus = exports.RequirementsStatus || (exports.RequirementsStatus = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmVxdWlyZW1lbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL1JlcXVpcmVtZW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQTs7Ozs7OztHQU9HO0FBQ0gsSUFBWSxZQUVYO0FBRkQsV0FBWSxZQUFZO0lBQ3RCLDJCQUFXLENBQUE7QUFDYixDQUFDLEVBRlcsWUFBWSxHQUFaLG9CQUFZLEtBQVosb0JBQVksUUFFdkI7QUFFRCxJQUFZLGtCQUlYO0FBSkQsV0FBWSxrQkFBa0I7SUFDNUIseUNBQW1CLENBQUE7SUFDbkIsNkNBQXVCLENBQUE7SUFDdkIsdUNBQWlCLENBQUE7QUFDbkIsQ0FBQyxFQUpXLGtCQUFrQixHQUFsQiwwQkFBa0IsS0FBbEIsMEJBQWtCLFFBSTdCIn0=